import React, { lazy, Suspense } from "react";
import Header from "./Header";
import Hero from "./Hero";
import LazyLoad from "./LazyLoad";
import PainToOutcomes from "./PainToOutcomes";

// Lazy load heavy components
const FeaturesSection = lazy(() => import("./FeaturesSection"));
const ProductShowcase = lazy(() => import("./ProductShowcase"));
const FrameworksSection = lazy(() => import("./FrameworksSection"));
const TestimonialsSection = lazy(() => import("./TestimonialsSection"));
const CTASection = lazy(() => import("./CTASection"));
const Footer = lazy(() => import("./Footer"));

const LoadingFallback = ({ height = "h-96" }) => (
  <div className={`${height} flex items-center justify-center`}>
    <div className="w-8 h-8 border-2 border-purple-400 border-t-transparent rounded-full animate-spin"></div>
  </div>
);

const LandingPage = () => {
  return (
    <div
      className="min-h-screen text-white overflow-x-hidden"
      style={{
        background:
          "linear-gradient(180deg, #0A0A23 0%, #1A1A3A 50%, #0F0F2B 100%)",
      }}
    >
      <Header />
      <Hero />

      {/* Product section - load immediately (includes AI features) */}
      <ProductShowcase />

      {/* Pain Points to Outcomes Section */}
      <PainToOutcomes />

      {/* Frameworks section - load immediately */}
      <FrameworksSection />

      {/* Testimonials section - load immediately */}
      <TestimonialsSection />

      {/* <Suspense fallback={<LoadingFallback height="h-screen" />}>
        <LazyLoad fallback={<LoadingFallback height="h-screen" />}>
          <FeaturesSection />
        </LazyLoad>
      </Suspense> */}

      <Suspense fallback={<LoadingFallback />}>
        <LazyLoad fallback={<LoadingFallback />}>
          <CTASection />
        </LazyLoad>
      </Suspense>

      <Suspense fallback={<LoadingFallback />}>
        <LazyLoad fallback={<LoadingFallback />}>
          <Footer />
        </LazyLoad>
      </Suspense>
    </div>
  );
};

export default LandingPage;
